import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import GlowButton from '../../../components/GlowButton';
import VideoModal from '../../../components/VideoModal';

export default function FinalCTA() {
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <section 
      className="relative py-32 px-6 overflow-hidden"
      style={{
        background: 'linear-gradient(180deg, #000000 0%, #0a0e14 20%, #1b2433 50%, #0a0e14 80%, #000000 100%)'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-tr from-purple-900/5 via-transparent to-green-900/5"></div>

      <div className="max-w-5xl mx-auto relative z-10 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-500/10 to-green-500/10 border border-purple-500/30 rounded-full mb-8">
          <i className="ri-rocket-fill text-purple-400"></i>
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-300 to-green-300 text-sm font-medium">{t('finalCTA.badge')}</span>
        </div>

        <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          {t('finalCTA.title')}<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-green-400">{t('finalCTA.titleHighlight')}</span>
        </h2>

        <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
          {t('finalCTA.subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-16">
          <GlowButton variant="secondary" className="text-lg px-10 py-5 font-bold" onClick={() => setVideoModalOpen(true)}>
            <i className="ri-play-circle-fill text-2xl"></i>
            {t('finalCTA.watchDemo')}
          </GlowButton>

          <GlowButton 
            variant="outline" 
            className="text-lg px-10 py-5 font-bold border-white text-white hover:bg-white hover:text-gray-950"
            href="https://wa.me/5519988332466?text=Ol%C3%A1%2C%20estou%20vindo%20pelo%20site%20da%20Automat."
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="ri-whatsapp-fill text-2xl"></i>
            {t('finalCTA.talkToSpecialist')}
          </GlowButton>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-xl p-6">
            <i className="ri-settings-3-fill text-3xl text-purple-400 mb-3"></i>
            <p className="text-gray-300 text-sm">{t('finalCTA.features.setup')}</p>
          </div>
          <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-xl p-6">
            <i className="ri-shield-check-fill text-3xl text-green-400 mb-3"></i>
            <p className="text-gray-300 text-sm">{t('finalCTA.features.guarantee')}</p>
          </div>
          <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-xl p-6">
            <i className="ri-customer-service-fill text-3xl text-blue-400 mb-3"></i>
            <p className="text-gray-300 text-sm">{t('finalCTA.features.support')}</p>
          </div>
          <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-xl p-6">
            <i className="ri-lock-fill text-3xl text-orange-400 mb-3"></i>
            <p className="text-gray-300 text-sm">{t('finalCTA.features.secure')}</p>
          </div>
        </div>
      </div>

      <VideoModal 
        isOpen={videoModalOpen}
        onClose={() => setVideoModalOpen(false)}
        videoUrl="https://youtu.be/wjB-jFEXMsw?si=7xRkqCtSrcGdPfy4"
      />
    </section>
  );
}
